module.exports = __webpack_public_path__ + "img/intro_map.b0cef765.jpg";